module.exports = __webpack_public_path__ + "img/antes_despues_122.7e0665a5.png";